import createIcon from '../../createIcon';

/**
 * @component @name Warehouse
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMjFWN0wxMiAzTDIgN1YyMUg3VjEySDE3VjIxSDIyWk0xMSAxOUg5VjIxSDExVjE5Wk0xMyAxNkgxMVYxOEgxM1YxNlpNMTUgMTlIMTNWMjFIMTVWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Warehouse = createIcon('Warehouse', [
  [
    'path',
    {
      d: 'M22 21V7L12 3L2 7V21H7V12H17V21H22ZM11 19H9V21H11V19ZM13 16H11V18H13V16ZM15 19H13V21H15V19Z',
      key: '1jcv5n',
    },
  ],
]);

export default Warehouse;
